export const optionsThroughput = {
  plugins: {},

  scales: {
    yAxis: {
      beginAtZero: true,

      ticks: {
        color: "#ffffff",
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "Throughput (Kbps)",
      },
    },

    xAxis: {
      ticks: {
        color: "#ffffff",
        maxTicksLimit: 10,
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "Duration (Sec)",
      },
    },
  },
  tooltips: {
    bodyFontSize: 10,
  },
};
